import React from 'react';

export default function BacBlock2Value() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-paper border-b border-line">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-20 max-w-3xl">
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink mb-6 tracking-tight">
            No compras otra plataforma para mirar pacientes.
          </h2>
          <p className="text-[18px] md:text-[20px] text-ink-soft leading-[1.6]">
            Instalas capacidad para operar una población.
          </p>
        </div>
        <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-stretch gap-4 lg:gap-6">
          <div className="flex-1 bg-[rgb(239,239,255)] rounded-xl flex flex-col text-left px-[15%] py-[5%] md:p-[5%]">
            <div className="text-[14px] font-semibold text-ink-soft/70 mb-4">La red entrega</div>
            <div className="text-[20px] font-bold text-ink mb-6">Directrices y Datos</div>
            <div className="text-[16px] text-ink-soft space-y-3">
              <p>Población objetivo</p>
              <p>Evidencia clínica histórica</p>
              <p>Capacidad instalada (cupos)</p>
              <p>Reglas clínicas acordadas</p>
            </div>
          </div>
          <div className="flex-1 bg-[#ccccff] rounded-xl px-[15%] py-[5%] md:p-[5%] flex flex-col text-left shadow-sm border border-brand/20">
            <div className="text-[14px] font-semibold text-ink-soft mb-4">BAC entrega</div>
            <div className="text-[20px] font-bold text-ink mb-6">Capacidad Operacional</div>
            <div className="text-[16px] text-ink-soft space-y-3">
              <p>Priorización continua</p>
              <p>Operación y contacto</p>
              <p>Coordinación y agendamiento</p>
              <p>Rescate de inasistencias</p>
              <p>Trazabilidad y verificación</p>
            </div>
          </div>
          <div className="flex-1 bg-[rgb(207,249,255)] rounded-xl flex flex-col text-left px-[15%] py-[5%] md:p-[5%]">
            <div className="text-[14px] font-semibold text-ink-soft/70 mb-4">APS entrega</div>
            <div className="text-[20px] font-bold text-brand mb-6">Clínica Pura</div>
            <div className="text-[16px] text-ink-soft space-y-3">
              <p>Prestaciones sanitarias</p>
              <p>Diagnóstico profesional</p>
              <p>Tratamiento y ajuste</p>
              <p>Planes de cuidado</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
